module.exports = "Implementation of Cascading Dropdown Type is still left..........\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/oldCentralPannel/cascading-dropdown-type/cascading-dropdown-type.component.html
// module id = ./src/app/oldCentralPannel/cascading-dropdown-type/cascading-dropdown-type.component.html
// module chunks = main